// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDAgk8tlKfdJGerPq6bikNvhmiRDGyY0Yg",
  authDomain: "vinogenes-5207a.firebaseapp.com",
  projectId: "vinogenes-5207a",
  storageBucket: "vinogenes-5207a.firebasestorage.app",
  messagingSenderId: "467204490896",
  appId: "1:467204490896:web:bd34e46afdc0cad47a3a15"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "europe-west1");
export default app; 